/* AZ & CO. — two things the page was paying for and not using.

   Classic script, deferred. Nothing here is required for the page to be
   correct: delete the file and the two lines that load it in
   layout/theme.liquid and everything still works, only slower.

   1. The hero images past the second are held on data attributes and put
      back just before the rotation reaches them, the rest on idle.

   2. Nothing at all when the rotation is not running.

   3. (v7) The first slide ships already showing, marked data-first so the
      stylesheet skips its entrance animation. Once the rotation moves off
      it, data-first comes off too, so every later appearance of that slide
      condenses in like the others. */

(function () {
  'use strict';

  var host = document.getElementById('spotlight');
  if (!host) return;

  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hydrate (img) {
    if (!img || !img.getAttribute('data-src')) return;
    var set = img.getAttribute('data-srcset');
    var sizes = img.getAttribute('data-sizes');
    if (sizes) img.setAttribute('sizes', sizes);
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', img.getAttribute('data-src'));
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-sizes');
    img.classList.remove('spot-wait');
  }

  function ahead () {
    var on = host.querySelector('.spot[data-on]');
    var next = on && on.nextElementSibling;
    if (!next) next = host.querySelector('.spot');
    if (next) hydrate(next.querySelector('img[data-src]'));
  }

  function rest () {
    var waiting = host.querySelectorAll('img[data-src]');
    for (var i = 0; i < waiting.length; i++) hydrate(waiting[i]);
  }

  if (still) return;

  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var el = list[i].target;
        if (el.hasAttribute && el.hasAttribute('data-first') && !el.hasAttribute('data-on')) {
          el.removeAttribute('data-first');
        }
      }
      ahead();
    }).observe(host, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-on']
    });
  }

  function begin () {
    ahead();
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(rest, { timeout: 5000 });
  }

  if (document.readyState === 'complete') begin();
  else addEventListener('load', begin);
}());